import { createStore, Store } from 'vuex';
import stateStoreData from './state/stateStoreData';
import countryStoreData from './country/countryStoreData';
import displayStoreData from './displayStoreData';
interface RootState {
  
  isLoggedIn: boolean;
  isLoading: boolean;
}

const initialState: RootState = {
  isLoggedIn: false,
  isLoading: false
};

export default createStore({
  state: initialState,
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    stateStoreData,
    countryStoreData,
    displayStoreData
  }});

  declare module "@vue/runtime-core" {
    interface ComponentCustomProperties {
      $store: Store<RootState>;
    }
  }